import { render, staticRenderFns } from "./userChoose.vue?vue&type=template&id=4e6873a0&"
import script from "./userChoose.vue?vue&type=script&lang=js&"
export * from "./userChoose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports